import { Component } from '@angular/core';

@Component({
  selector: 'app-card-infi',
  templateUrl: './card-infi.component.html',
  styleUrls: ['./card-infi.component.scss']
})
export class CardInfiComponent {
  onNavigateCapacite() {
    window.open(
      'https://www.inandfi-credits.fr/calculette-capacite-emprunt',
      '_blank',
      'noopener,noreferrer'
    );
  }
}
